import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import {ServiceAccountService} from "../../user/service-account.service";
import {handleErrors} from "../../misc/handle-errors.decorator";

export interface SelectPartnerDialogModel {
  filters: any;
}

@Component({
  templateUrl: "./dialog-select-partner.template.pug",
  providers: [
    ServiceAccountService,
  ],
})
export class SelectPartnerDialogComponent
  extends DialogComponent<SelectPartnerDialogModel, any> implements SelectPartnerDialogModel {
  public filters: any;
  public error: Error;
  public partners: any[] = [];
  public partnerSelected: string;

  static showSelectPartnerDialogModal(dialogService: DialogService, inputs: SelectPartnerDialogModel):
  Observable<any> {
    return dialogService.addDialog(SelectPartnerDialogComponent, inputs, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  @handleErrors()
  public async loadData(): Promise<void> {
    this.partners = await this.serviceAccountService.getPartners(this.filters);
  }

  cancel(): void {
    this.result = {success: false};
    this.close();
  }

  /**
   *
   * @return {Promise<void>}
   */
  @handleErrors()
  async selectPartner(): Promise<void> {
    if (!this.partnerSelected) throw new Error("No Partner Selected");
    this.result = {success: true, partnerSelected: this.partnerSelected};
    this.close();
  }

  ngOnInit(): void {
    this.loadData();
  }

  constructor(
    public dialogService: DialogService,
    private serviceAccountService: ServiceAccountService,
  ) {
    super(dialogService);
  }
}
